import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import {
  MENU_NOTIFICATIONS_INTIAL_QUERY_STATE,
  getNotifiactionInfo,
  newNotificationMessage,
} from "common/components/NotificationsMenu/components/constants"
import AlbaranService from "common/services/AlbaranService"
import FacturaService from "common/services/FacturaService"
import { NotificationsService } from "common/services/NotificationsService"
import PedidoService from "common/services/PedidoService"
import PresupuestoService from "common/services/PresupuestoService"
import showToast from "common/utils/notification"
import { convertDateFromUtcToLocale, getUniqueListBy } from "common/utils/utils"
import { showVerDocumentoModal } from "features/Documentos/redux/documentosSlice"
import useCambiarEmpresa from "features/MisEmpresas/hooks/useCambiarEmpresa"
import {
  NOTIFICATIONS_INITIAL_QUERY_STATE,
  notificationsQueryState,
} from "features/Notifications/components/constants"
import { useDispatch } from "hooks/useDispatch"
import { createContext, useContext, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { NOTIFICATIONS } from "routes/RoutePaths"

const NotificationsContext = createContext({})

const NotificationsProvider = ({ children }: $TSMigrationFixMe) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [allNotifications, setAllNotifications] = useState({
    list: [],
    totalCount: 0,
    queryState: NOTIFICATIONS_INITIAL_QUERY_STATE,
    notUpdated: true,
  })
  const [unReadNotifications, setUnReadNotifications] = useState({
    list: [],
    totalCount: 0,
    queryState: MENU_NOTIFICATIONS_INTIAL_QUERY_STATE,
    notUpdated: true,
  })
  const [allNotificationsLoading, setAllNotificationsLoading] = useState(false)
  const [unReadNotificationsLoading, setUnReadNotificationsLoading] =
    useState(false)
  const [isNewNotification, setIsNewNotification] = useState(null)
  const [notificationClicked, setNotificationClicked] = useState(false)
  const [companyActiveUpdated, setCompanyActiveUpdated] = useState(true)
  const [openNotificationsMenu, setOpenNotificationsMenu] = useState(false)
  const { setEmpresaActiva } = useCambiarEmpresa()
  const {
    activeCompany: { id: empresaActivaId },
  } = useUsuarioEmpresaActiva()

  const showNotifications = () => setOpenNotificationsMenu(true)

  const hideNotifications = () => setOpenNotificationsMenu(false)

  const stateToUse = (isMenu: $TSMigrationFixMe) =>
    isMenu
      ? {
          value: unReadNotifications,
          set: setUnReadNotifications,
          initialQueryState: MENU_NOTIFICATIONS_INTIAL_QUERY_STATE,
        }
      : {
          value: allNotifications,
          set: setAllNotifications,
          initialQueryState: NOTIFICATIONS_INITIAL_QUERY_STATE,
        }

  const setNotificationsQueryState = (
    queryState: $TSMigrationFixMe,
    isMenu: $TSMigrationFixMe
  ) => {
    const { value, set, initialQueryState } = stateToUse(isMenu)
    set({
      ...value,
      notUpdated: true,
      queryState: queryState || initialQueryState,
    })
  }

  const seeAllNotifications = () => {
    history.push(NOTIFICATIONS)
    hideNotifications()
  }

  const retrieveNotification = () => {
    // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable...
    return JSON.parse(sessionStorage.getItem("selectedNotification"))
  }

  const removeNotification = () => {
    sessionStorage.removeItem("selectedNotification")
  }

  const checkEmpresaActiva = (notification: $TSMigrationFixMe) => {
    if (empresaActivaId === notification?.empresaId) {
      setNotificationClicked(true)
    } else {
      setCompanyActiveUpdated(false)
      setEmpresaActiva(notification?.empresaId)
    }
  }

  const handleOpenNotification = (data: $TSMigrationFixMe) => {
    sessionStorage.setItem("selectedNotification", JSON.stringify(data))
    checkEmpresaActiva(data)
  }

  // @ts-expect-error TS(7030): Not all code paths return a value.
  const chooseService = () => {
    const type = retrieveNotification()?.type
    switch (type) {
      case "Albarán":
        return AlbaranService
      case "Presupuesto":
        return PresupuestoService
      case "Pedido":
        return PedidoService
      case "Factura":
        return FacturaService
      default:
        break
    }
  }

  const mapNotifications = (notifications = []) =>
    notifications.map((n) => ({
      // @ts-expect-error TS(2698): Spread types may only be created from object types...
      ...n,
      // @ts-expect-error TS(2339): Property 'creationTime' does not exist on type 'ne...
      creationTime: convertDateFromUtcToLocale(n.creationTime),
    }))

  const handleFetchNotificationsResponse = (
    response: $TSMigrationFixMe,
    isMenu: $TSMigrationFixMe
  ) => {
    const { value, set } = stateToUse(isMenu)
    const { items, totalCount } = response.data
    const list =
      value.queryState.skipCount > 0
        ? [...value.list, ...mapNotifications(items)]
        : mapNotifications(items)
    // @ts-expect-error TS(2322): Type 'any[]' is not assignable to type 'never[]'.
    set({ ...value, list, totalCount, notUpdated: false })
  }

  const updateNotificationOnRealTime = (isMenu: $TSMigrationFixMe) => {
    const { value, set } = stateToUse(isMenu)

    const newQueryState = {
      ...(isMenu
        ? value.queryState
        : notificationsQueryState(value.queryState)),
      maxResultCount: 1,
      skipCount: 0,
    }

    NotificationsService.getNotifications(newQueryState)
      .then((response) => {
        const { items, totalCount } = response.data
        const listWithDuplicatedItems = [
          ...mapNotifications(items),
          ...value.list,
        ]
        const list = getUniqueListBy(listWithDuplicatedItems, "id")
        const hasNewItems = listWithDuplicatedItems.length === list.length
        const queryState = hasNewItems
          ? {
              ...value.queryState,
              skipCount: value.queryState.skipCount + 1,
            }
          : value.queryState
        // @ts-expect-error TS(2322): Type 'unknown[]' is not assignable to type 'never[...
        set({ ...value, list, totalCount, queryState })
      })
      .catch(showToast.errorServidor)
  }

  const fetchPageNotifications = () => {
    setAllNotificationsLoading(true)
    const queryState = notificationsQueryState(allNotifications.queryState)
    NotificationsService.getNotifications(queryState)
      // @ts-expect-error TS(2345): Argument of type '(response: $TSFixMe, isMenu: $TSFixMe) => ...
      .then(handleFetchNotificationsResponse)
      .catch(showToast.errorServidor)
      .finally(() => setAllNotificationsLoading(false))
  }

  const fetchMenuNotifications = () => {
    setUnReadNotificationsLoading(true)
    NotificationsService.getNotifications(unReadNotifications.queryState)
      .then((response) => handleFetchNotificationsResponse(response, true))
      .catch(showToast.errorServidor)
      .finally(() => setUnReadNotificationsLoading(false))
  }

  const redirectToNotificationPage = (notification: $TSMigrationFixMe) => {
    // @ts-expect-error TS(2339): Property 'path' does not exist on type '{ type: st...
    const { path } = getNotifiactionInfo(notification.type)
    history.push(path)
  }

  const openNotification = async () => {
    const notification = retrieveNotification()
    if (notification) {
      const markAsReadIfIsNotRead = notification.read
        ? []
        : [NotificationsService.markNotificationAsRead(true, notification.id)]
      Promise.all([
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        chooseService().getById(notification.messageId),
        ...markAsReadIfIsNotRead,
      ])
        .then((response) => {
          const [item] = response
          removeNotification()
          redirectToNotificationPage(notification)
          dispatch(showVerDocumentoModal(item?.data))
          // @ts-expect-error TS(2554): Expected 2 arguments, but got 0.
          setNotificationsQueryState()
          setNotificationsQueryState(null, true)
        })
        .catch(showToast.errorServidor)
        .finally(() => setNotificationClicked(false))
    }
  }

  const resetNotificationsQueryStateSkipCount = (isMenu: $TSMigrationFixMe) => {
    const { value } = stateToUse(isMenu)
    const newState = { ...value.queryState, skipCount: 0 }
    setNotificationsQueryState(newState, isMenu)
  }

  const markAllNotificationsAsRead = () => {
    NotificationsService.markAllNotificationsAsRead()
      .then(() => {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        resetNotificationsQueryStateSkipCount()
        resetNotificationsQueryStateSkipCount(true)
      })
      .catch(showToast.errorServidor)
  }

  const openNotificationAfterChangingActiveCompany = () => {
    if (!companyActiveUpdated) {
      setNotificationClicked(true)
      setCompanyActiveUpdated(true)
    }
  }

  const updateNotifications = (message: $TSMigrationFixMe) => {
    updateNotificationOnRealTime(true)
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    updateNotificationOnRealTime()
    setIsNewNotification(null)
    showToast.success({
      body: newNotificationMessage(message),
    })
  }

  useEffect(() => {
    if (notificationClicked) openNotification()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationClicked])

  useEffect(() => {
    openNotificationAfterChangingActiveCompany()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresaActivaId, companyActiveUpdated])

  useEffect(() => {
    if (unReadNotifications.notUpdated) fetchMenuNotifications()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unReadNotifications.notUpdated])

  useEffect(() => {
    if (isNewNotification) {
      updateNotifications(isNewNotification)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNewNotification])

  return (
    <NotificationsContext.Provider
      value={{
        allNotifications,
        unReadNotifications,
        handleOpenNotification,
        markAllNotificationsAsRead,
        openNotificationsMenu,
        showNotifications,
        hideNotifications,
        seeAllNotifications,
        setIsNewNotification,
        fetchPageNotifications,
        setNotificationsQueryState,
        allNotificationsLoading,
        unReadNotificationsLoading,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  )
}

export const useNotificationsContext = () => useContext(NotificationsContext)

export default NotificationsProvider
